import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-installation-ceremony',
  templateUrl: './installation-ceremony.component.html',
  styleUrls: ['./installation-ceremony.component.scss']
})
export class InstallationCeremonyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
